import React from 'react';
import Relay from 'react-relay';
import PropTypes from 'prop-types';

import mobileCheck from 'bunsen/helpers/mobileCheck';
import { SAVE_ITEM_FLOW } from 'dibs-auth-modal/dist/constants';
import userHelper from '../../../global/core/commonjs/userHelper';
import folderTracking from '../../../favorites/shared/folderTracking.es';
import { CALLOUT_TYPE_SAVE_TO_FOLDER } from '../../../components/Callout/calloutHelper.es';

import FolderComponent from 'dibs-portfolio-folder';
import Callout from '../../../components/Callout/Callout';

import styles from './PdpFolderItem-style.scss';
import { copy as calloutCopy } from './PdpFolderItemCallout.json';

function getRelayVariables({ userId, itemId }) {
    return {
        userId,
        loadItemData: true,
        primaryItemPk: itemId,
        selectedItemIds: [itemId]
    };
}

class PdpFolderItem extends React.Component {
    constructor(props) {
        super(props);

        this.authModalShow = this.authModalShow.bind(this);
    }
    authModalShow(showFolderModal) {
        userHelper.checkLogin({
            label: 'save item - product page'
        }, SAVE_ITEM_FLOW).then(showFolderModal);
    }
    render() {
        const { viewer, callout, ...params } = this.props;

        return (
            <div className={styles.pdpFolderItem} data-tn="item-save-to-folder">
                <FolderComponent
                    viewer={viewer}
                    {...getRelayVariables(params)}
                    trackingHooks={folderTracking}

                    // handlers
                    authModalShow={this.authModalShow}
                />

                {/* SaveToFolder callout */}
                { !mobileCheck.any() ?
                    <Callout
                        callout={callout}
                        copy={calloutCopy}
                        type={CALLOUT_TYPE_SAVE_TO_FOLDER}
                    />
                : null }
            </div>
        );
    }
}

PdpFolderItem.propTypes = {
    userId: PropTypes.string,
    itemId: PropTypes.string,
    viewer: PropTypes.object,
    callout: PropTypes.object
};

export default Relay.createContainer(
    PdpFolderItem, {
        initialVariables: {
            userId: null,
            itemId: null,
            loadItemData: true,
            primaryItemPk: null,
            selectedItemIds: []
        },
        prepareVariables: params => getRelayVariables(params),
        fragments: {
            viewer: params => Relay.QL`
                fragment on Viewer {
                    ${FolderComponent.getFragment('viewer', params)}
                }
            `
        }
    }
);



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Favorites/PdpFolderItem.jsx